import React, { useState } from 'react';
import { XIcon, KeyIcon } from 'lucide-react';
interface PinVerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onVerify: () => void;
}
export function PinVerificationModal({
  isOpen,
  onClose,
  onVerify
}: PinVerificationModalProps) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);
  const handleSubmit = () => {
    if (pin === '1234') {
      setError(false);
      onVerify();
      setPin('');
    } else {
      setError(true);
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-395">
      <div className="bg-white rounded-lg p-6 w-[400px]" data-id="element-396">
        <div className="flex justify-between items-center mb-4" data-id="element-397">
          <h2 className="text-lg font-medium flex items-center gap-2" data-id="element-398">
            <KeyIcon className="h-5 w-5 text-[#ec8301]" data-id="element-399" />
            Geschützter Bereich
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-400">
            <XIcon className="h-5 w-5" data-id="element-401" />
          </button>
        </div>
        <p className="text-gray-600 mb-4" data-id="element-402">
          Bitte geben Sie Ihre PIN ein, um auf diesen Bereich zuzugreifen.
        </p>
        <div className="space-y-4" data-id="element-403">
          <input type="password" value={pin} onChange={e => {
          setPin(e.target.value);
          setError(false);
        }} placeholder="PIN eingeben" className={`w-full border ${error ? 'border-red-500' : 'border-gray-300'} rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-[#ec8301]`} data-id="element-404" />
          {error && <p className="text-red-500 text-sm" data-id="element-405">Ungültige PIN</p>}
        </div>
        <div className="mt-6 flex justify-end gap-3" data-id="element-406">
          <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-407">
            Abbrechen
          </button>
          <button onClick={handleSubmit} className="px-4 py-2 bg-[#ec8301] text-white rounded-lg hover:bg-[#ec8301]/90" data-id="element-408">
            Bestätigen
          </button>
        </div>
      </div>
    </div>;
}